<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          class="tab-text"
          v-for="(item, index) in seteList"
          :key="index"
        ></el-tab-pane>
      </el-tabs>
      <div class="item-box-content" style="padding-top:20px" v-if="activeName === '1'">
        <div class="title-font-style">
          <span>开票管理</span>
        </div>
        <div style="padding: 20px 20px 0px 30px">
          <i class="el-icon-warning-outline"></i>
          <small
            style="color:#D35E5E;"
          >配置说明：业务提交开票申请，如单次提交金额达到上限金额，系统将自动拆分申请；财务单次开票金额达到上限，系统直接报错，无法继续。</small>
          <el-form class="details-line-height" style="padding-top:20px">
            <el-form-item label="单次开票上限金额:" :rules="filter_rules({required:true})">
              <el-input
                v-model="invocieAmountLimit"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                autocomplete="off"
                placeholder="请输入正数"
                style="width:150px;padding-left:10px;margin-top:-20px"
              ></el-input>元
            </el-form-item>
          </el-form>
          <el-button type="primary" letter-spacing @click="onSubmit">提交</el-button>
        </div>
      </div>
      <div v-if="activeName==='2'">
        <finance-seach
          ref="financeSeachRefs"
          :column-option="setetabs"
          :expression-array="['taxpoint']"
          :timer-array="['editDate']"
          @onSearch="onSearch"
        ></finance-seach>
        <div class="box-table" :style="{height: $store.state.Sell.height+'px'}">
          <el-table
            border
            ref="tableRef"
            :data="list"
            :max-height="$store.state.Sell.height"
            tooltip-effect="dark"
            :header-cell-style="tableHeader"
          >
            <el-table-column prop="classTwo" label="二级分类名称"></el-table-column>
            <el-table-column prop="classType" label="三级分类名称"></el-table-column>
            <el-table-column label="税率" prop="taxpoint">
              <template slot-scope="scope">{{scope.row.taxpoint|perCentFilter}}</template>
              <!-- <template v-slot="{row}">{{(row.taxpoint*100).toFixed(2) || 13}}%</template> -->
            </el-table-column>
            <el-table-column label="最后更新时间">
              <template slot-scope="scope">{{ scope.row.editDate | dateFilterL}}</template>
            </el-table-column>

            <el-table-column fixed="right" label="操作">
              <template slot-scope="scope">
                <el-button type="text" prop="processSecState" @click="edit(scope.row)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination">
          <pagination
            :pageSize="pageSize"
            :currentPage="currentPage"
            :total="total"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
          ></pagination>
        </div>
      </div>

      <!-- 编辑 弹框 -->
      <el-dialog title="编辑" :visible.sync="dialogFormVisible" append-to-body width="500px">
        <div style="padding-left:30px;line-height: 14px">
          <div>二级分类名称：{{formObj.classTwo}}</div>
          <div style="margin:20px 0">三级分类名称：{{formObj.classType}}</div>
          <div>
            税率：
            <el-input-number
              v-model="formObj.taxpoint"
              style="width:194px"
              :precision="2"
              :min="0"
              :controls="false"
            ></el-input-number>&nbsp;%
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="onSubmit">保 存</el-button>
          <el-button @click="dialogFormVisible = false">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 提交弹框 -->
      <open-or-close
        @onUpdataState="onUpdataState"
        content="确认提交本次设置。"
        title="提交确认"
        ref="openOrCloseRefs"
      ></open-or-close>
    </div>
  </div>
</template>
<script>
import pagination from '@/components/pagination'
import { seteList, setetabs } from '../financeManage/util/data'
import OpenOrClose from '@/components/OpenOrClose/index' // 提交审批,合同作废,合同审核不通过
import {
  queryAllProductClassBylevel,
  updateByIdus,
  queryFinanceSetting,
  updateInvocieAmountLimit
} from '@/api/fiance/fianceManage'
import financeSeach from '@/components/module/financeSeach'
export default {
  components: {
    'open-or-close': OpenOrClose,
    pagination,
    financeSeach
  },
  data () {
    return {
      columnArr: [],
      invocieAmountLimit: 0, // 开票值
      activeName: '2', // tabs选中状态
      formObj: {},
      seteList, // tabs状态
      setetabs, // 筛选条件
      loadingTable: false, // 列表loading
      dialogFormVisible: false,
      list: [], // 列表数据
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0 // 列表总数
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    // 编辑
    edit (row) {
      this.formObj = JSON.parse(JSON.stringify(row))
      this.formObj.taxpoint = (row.taxpoint * 100).toFixed(2)
      this.dialogFormVisible = true
    },
    // 提交
    onSubmit () {
      if (this.activeName === '1' && !this.invocieAmountLimit) {
        this.$message.error('必填项不能为空！')
        return
      }
      this.dialogFormVisible = false
      this.$refs.openOrCloseRefs.onInitial()
    },
    onUpdataState () {
      if (this.activeName === '1') {
        updateInvocieAmountLimit(this.invocieAmountLimit).then((res) => {
          if (res.data.code === 200) {
            this.$message.success('提交成功！')
            this.init()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else {
        const obj = JSON.parse(JSON.stringify(this.formObj))
        obj.taxpoint = obj.taxpoint / 100
        updateByIdus(obj).then((res) => {
          if (res.data.code === 200) {
            this.$message.success('提交成功！')
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    onSearch (arr) {
      this.pageSize = 30
      this.currentPage = 1
      this.columnArr = arr
      this.getList()
    },
    // tabs切换时触发的事件
    handleClick (tab) {
      this.currentPage = 1
      if (this.activeName === '2') {
        this.$refs.financeSeachRefs.searchReset()
      } else {
        this.init()
      }
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    init () {
      // 开票配置
      queryFinanceSetting().then((res) => {
        if (res.data.code === 200) {
          this.invocieAmountLimit = res.data.obj.invocieAmountLimit
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 列表数据
    getList () {
      this.loadingTable = true
      const params = {
        criteriaVoList: this.columnArr,
        queryPageName: ''
      }
      queryAllProductClassBylevel(
        0,
        this.currentPage,
        this.pageSize,
        params
      ).then((res) => {
        if (res.data.code === 200) {
          this.list = res.data.obj.records
          this.total = res.data.obj.total
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 页数
    handleSizeChange (val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
